import "../resource_collection/behavior.js";

// Each behavior must be registered with the name of the component template
class EventsBehavior extends Sparkle.PageBuilder.Components.ResourceCollectionAbstractBehavior {}
EventsBehavior.register("events");
